import React from 'react';
import styles from './utility.module.scss';
import {classNames} from '../../support/classnames.ts';

interface OwnProps {
    children: React.ReactNode;
    size: 'xs' | 'sm' | 'md' | 'lg';
}

export function ShowElement({children, size}: OwnProps) {
    return (
        <div
            className={classNames(styles.show_element, {
                [styles.show_xs]: size === 'xs',
                [styles.show_sm]: size === 'sm',
                [styles.show_md]: size === 'md',
                [styles.show_lg]: size === 'lg',
            })}
        >
            {children}
        </div>
    );
}
